function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M10,3.9c1.2,0,2.1,0.9,2.1,2.1S11.2,8.1,10,8.1S7.9,7.2,7.9,6S8.8,3.9,10,3.9L10,3.9z M10,12.9 c3,0,6.1,1.5,6.1,2.1v1.1H3.9V15C3.9,14.4,7,12.9,10,12.9L10,12.9z M10,2C7.8,2,6,3.8,6,6s1.8,4,4,4s4-1.8,4-4S12.2,2,10,2L10,2z  M10,11c-2.7,0-8,1.3-8,4v3h16v-3C18,12.3,12.7,11,10,11L10,11z"
});

var SvgName = function SvgName(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgName, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/name.7578b689.svg";
export { ForwardRef as ReactComponent };